// Dev auto-login removed — LoginForm now prefills from URL params in development.
// DevLoginLinks buttons navigate to /login?tenant=xxx&email=xxx&password=xxx
// which skips to the credentials step with fields pre-populated.
export function DevLogin() {
  return null;
}
